import { render, staticRenderFns } from "./CameraPreview.vue?vue&type=template&id=0a079224&"
import script from "./CameraPreview.vue?vue&type=script&lang=js&"
export * from "./CameraPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports